import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { IPreviewEvents, IPreviewFields } from '../components/types';
import { PreviewEvents } from './events';
import { Preview } from '../components/Preview';
import { CallSelectors } from '../../../../store/call/selectors';

const mapStateToProps = (
) => {
	return (
		state: IState
	): IPreviewFields => {
		return {
			isToken: !!CallSelectors.getToken(state),
			startedAt: CallSelectors.getStartedAt(state),
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IPreviewEvents => {
	return {
		onOpen: () => dispatch(PreviewEvents.onOpen()),
		onLeave: () => dispatch(PreviewEvents.onLeave()),
	}
};

export const PreviewHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(Preview);

PreviewHOC.displayName = 'PreviewHOC';
